import mediasMixins from 'root/mixins/mediasMixin.js'

export default {
  name: 'all-brands',
  mixins: [mediasMixins],
  data () {
    return {
    }
  },

  methods: {
  },
  
  computed: {
   
  },
  
  watch: {
   
  },
  
  mounted() {
    
  }

}



// WEBPACK FOOTER //
// ./web/webroot/_ui/responsive/common/js/src/components/content-pages/all-brands/all-brands.js